import React from 'react'
import { useSelector } from 'react-redux'

import { fetchRoles } from 'api/roles'
import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import { useAccess } from 'app/hooks/useAccess'
import { fetchAdminData, updateUserData } from 'app/store/actions/userEntity'

import { columns } from './config'

import { buildRoleColumn } from '../roleColumn'

const Admin = () => {
  const adminData = useSelector((state) => state.userEntityReducer.adminData)
  const [roles, setRoles] = React.useState([])
  // Only a Super Admin may set someone's role from THIS form. Everyone else
  // manages roles from HQ -> Roles & Permissions (which is itself permissioned).
  // Hiding the column also means the form never posts `role`, and edit_user is
  // partial, so a non-super-admin save cannot disturb the role at all.
  const { isSuperAdmin } = useAccess()

  // BaseForm's `select` widget takes a static {value: label} map, so the roles
  // have to be in hand before the column is built.
  React.useEffect(() => {
    let cancelled = false
    fetchRoles()
      .then((data) => {
        if (!cancelled) setRoles(data)
      })
      .catch(() => {
        // Non-fatal: without roles the column just offers "No role", and the
        // rest of the admin form keeps working.
      })
    return () => {
      cancelled = true
    }
  }, [])

  const columnsWithRole = React.useMemo(
    () => (isSuperAdmin ? [...columns, buildRoleColumn(roles)] : columns),
    [roles, isSuperAdmin]
  )

  return (
    <BaseEntity
      entity={constants.ADMIN}
      label={constants.ADMIN_LABEL}
      columns={columnsWithRole}
      data={adminData}
      fetchData={fetchAdminData}
      updateEntityData={updateUserData}
      disableDelete
    />
  )
}

export default Admin
